import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, DownloadIcon, FileTextIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-[#FAF7F2] py-24 md:py-32 relative overflow-hidden" data-id="element-76">
      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-77">
        <div className="flex flex-col md:flex-row items-center gap-16 md:gap-12" data-id="element-78">
          {/* Left: Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="w-full md:w-1/2 text-center md:text-left order-1" data-id="element-79">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1B4B5A] mb-6 leading-tight font-serif" data-id="element-80">
              Cómo salvar tu relación y recuperar la Paz Mental, incluso si
              sentís que ya lo intentaste todo
            </h1>

            <p className="text-sm md:text-base text-[#1B4B5A]/70 font-medium tracking-wide uppercase mb-6 font-sans" data-id="element-81">
              16 páginas. Sin relleno. Solo el protocolo exacto para los
              próximos 7 días.
            </p>

            <p className="text-lg md:text-xl text-[#7A7A6E] mb-10 leading-relaxed font-sans" data-id="element-82">
              Descubre el método práctico para reconstruir la comunicación,
              sanar heridas y blindar tu pareja contra las crisis financieras y
              el agotamiento mental.
            </p>

            <motion.a href="#cta" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} animate={{
            boxShadow: ['0 0 0 0 rgba(194, 113, 79, 0)', '0 0 0 15px rgba(194, 113, 79, 0.1)', '0 0 0 0 rgba(194, 113, 79, 0)']
          }} transition={{
            duration: 2.5,
            repeat: Infinity,
            repeatType: 'reverse'
          }} className="inline-block w-full md:w-auto bg-[#4fc251] text-white px-8 py-5 rounded-lg text-lg font-semibold shadow-[0_10px_25px_-5px_rgba(194,113,79,0.4)] hover:bg-[#A85D3F] transition-colors mb-6 text-center font-sans tracking-wide" data-id="element-83">
              QUIERO SALVAR MI RELACION
            </motion.a>

            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 md:gap-6 text-xs md:text-sm text-[#7A7A6E] font-sans" data-id="element-84">
              <div className="flex items-center gap-1.5" data-id="element-85">
                <DownloadIcon className="w-4 h-4 text-[#1B4B5A]" data-id="element-86" />
                Descarga inmediata
              </div>
              <div className="flex items-center gap-1.5" data-id="element-87">
                <ShieldCheckIcon className="w-4 h-4 text-[#1B4B5A]" data-id="element-88" />
                Pago seguro
              </div>
              <div className="flex items-center gap-1.5" data-id="element-89">
                <FileTextIcon className="w-4 h-4 text-[#1B4B5A]" data-id="element-90" />
                PDF
              </div>
            </div>
          </motion.div>

          {/* Right: Mockup */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="w-full md:w-1/2 flex justify-center order-2" data-id="element-91">
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative w-full max-w-[500px]" data-id="element-92">
              <img src="https://cdn.magicpatterns.com/uploads/hwX3ivC4uawLNTEz3AzNkw/Gemini_Generated_Image_gaw711gaw711gaw7.png" alt="Rescate de Pareja: Guía de Emergencia 2026 — Índice y Protocolo S.O.S" className="w-full h-auto rounded-2xl" style={{
              filter: 'drop-shadow(0 25px 50px rgba(27, 75, 90, 0.2))'
            }} data-id="element-93" />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}